import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useGenerateUploadUrlMutation } from "../redux/Apis/General";

const usePresignedUpload = () => {
  const lang = useSelector((state) => state.language.lang);
  const [generateUploadUrl] = useGenerateUploadUrlMutation();

  const uploadFileWithPresignedUrl = async (file) => {
    if (!(file instanceof File)) {
      toast.error("Invalid file selected");
      return null;
    }

    try {
      const { name, type } = file;

      // const { uploadURL, key } = await generateUploadUrl({
      //   filename: name,
      //   filetype: type,
      //   lang: lang,
      // }).unwrap();

      const presignRes = await generateUploadUrl({
        filename: name,
        filetype: type,
        lang,
      }).unwrap();
      const uploadURL = presignRes?.data?.uploadURL;
      const key = presignRes?.data?.key;

      await fetch(uploadURL, {
        method: "PUT",
        headers: { "Content-Type": type },
        body: file,
      });

      return key;
    } catch (err) {
      console.error("Presigned upload failed:", err);
      toast.error(err?.data?.message || "File upload failed");
      return null;
    }
  };

  return { uploadFileWithPresignedUrl };
};

export default usePresignedUpload;
